import { render, staticRenderFns } from "./loading-container.vue?vue&type=template&id=b90bc1f0"
import script from "./loading-container.vue?vue&type=script&lang=js"
export * from "./loading-container.vue?vue&type=script&lang=js"
import style0 from "./loading-container.vue?vue&type=style&index=0&id=b90bc1f0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports